
import { Mail } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface EmptyClaimRequestsProps {
  isLoading: boolean;
  type: 'pending' | 'processed';
}

const EmptyClaimRequests = ({ isLoading, type }: EmptyClaimRequestsProps) => {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="pt-6">
          <p className="text-center py-4 text-redflags-gray">Loading requests...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="text-center py-8">
          <Mail className="w-12 h-12 mx-auto mb-3 text-gray-300" />
          <p className="text-lg mb-2">No {type} requests</p>
          <p className="text-sm text-redflags-gray">
            {type === 'pending'
              ? 'There are no company claim requests waiting for your approval.'
              : 'There are no company claim requests that have been processed yet.'}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default EmptyClaimRequests;
